/**
 * Admin V3 — Russian label dictionary
 *
 * Reserved for owner-provided Russian translations.
 * Missing keys automatically fall back to French via t() (see index.js).
 */

const ru = {};

export default ru;
